var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



// WEBPACK FOOTER //
// ../lodash/_Symbol.js